import React, { useState } from 'react';

const PASEP = () => {
    const [mesesTrabalhados, setMesesTrabalhados] = useState('');
    const [salarioMinimo, setSalarioMinimo] = useState('');
    const [resultado, setResultado] = useState(null);

    const calcularPASEP = () => {
        // Validação de entradas
        if (!mesesTrabalhados || !salarioMinimo) {
            alert('Por favor, preencha todos os campos.');
            return;
        }

        // Converte as entradas para números
        const mesesNum = parseInt(mesesTrabalhados);
        const salarioMinimoNum = parseFloat(salarioMinimo);

        if (isNaN(mesesNum) || isNaN(salarioMinimoNum)) {
            alert('Por favor, insira valores válidos.');
            return;
        }

        // Verificar se os meses trabalhados são válidos
        if (mesesNum < 1 || mesesNum > 12) {
            alert('O número de meses trabalhados deve estar entre 1 e 12.');
            return;
        }

        // Cálculo do valor proporcional do PASEP
        const valorPASEP = (salarioMinimoNum / 12) * mesesNum;

        // Formatar o valor em reais
        const formatarValor = (valor) => `R$ ${valor.toFixed(2).replace('.', ',')}`;

        // Atualiza o resultado
        setResultado({
            mesesTrabalhados: mesesNum,
            salarioMinimo: formatarValor(salarioMinimoNum),
            valorPASEP: formatarValor(valorPASEP),
        });
    };

    const limparCampos = () => {
        setMesesTrabalhados('');
        setSalarioMinimo('');
        setResultado(null);
    };

    return (
        <div className='container-calculo'>
            <div className='label-calculo'>
                <h1 className='titulo-calculo'>Cálculo do PASEP</h1>
            </div>
            <div className='label-calculo'>
                <h3 className='txt-calculo'>Meses Trabalhados no Ano Anterior:</h3>
                <input
                    className='input-calculo'
                    type='number'
                    min="1"
                    max="12"
                    value={mesesTrabalhados}
                    onChange={(e) => setMesesTrabalhados(e.target.value)}
                />
            </div>
            <div className='label-calculo'>
                <h3 className='txt-calculo'>Salário Mínimo Atual:</h3>
                <input
                    className='input-calculo'
                    type='number'
                    value={salarioMinimo}
                    onChange={(e) => setSalarioMinimo(e.target.value)}
                />
            </div>

            <div className="btn-container">
                <button className='btn-calculo-limpar' onClick={limparCampos}>
                    Limpar
                </button>
                <button className='btn-calculo' onClick={calcularPASEP}>
                    Calcular
                </button>

            </div>
            {resultado && (<hr className='hr-separador'></hr>)}
            {resultado && (
                <div className='resultado-calculo'>
                    <h3 className='titulo-resultado'>Resultado do Cálculo do PASEP</h3>
                    <p className='txt-resultado'>Meses trabalhados: {resultado.mesesTrabalhados}</p>
                    <p className='txt-resultado'>Salário mínimo: {resultado.salarioMinimo}</p>
                    <hr className='hr-resultado' />
                    <p className='txt-resultado'>Valor do PASEP: {resultado.valorPASEP}</p>
                </div>
            )}
        </div>
    );
};

export default PASEP;
